// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saleInformation_v9nHS {
  display: flex;
  flex-direction: column;
  gap: var(--size-padLarge);
}

@media only screen and (max-width: 1023px) {
  .saleInformation_v9nHS {
    min-height: 556px;
  }
}

.container_bwPrU {
  background: #FFFFFF;
  border: 1px solid var( --color-base100 );
  border-radius: 8px;
  padding: 12px;
}

.icon_jwBWT {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
`, "",{"version":3,"sources":["webpack://./../../packages/recovr-plugins/lib/views/salesFlow/screens/SaleInformation.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB","sourcesContent":[".saleInformation {\n  display: flex;\n  flex-direction: column;\n  gap: var(--size-padLarge);\n}\n\n@media only screen and (max-width: 1023px) {\n  .saleInformation {\n    min-height: 556px;\n  }\n}\n\n.container {\n  background: #FFFFFF;\n  border: 1px solid var( --color-base100 );\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.icon {\n  width: 24px;\n  height: 24px;\n  margin-right: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"saleInformation": `saleInformation_v9nHS`,
	"container": `container_bwPrU`,
	"icon": `icon_jwBWT`
};
export default ___CSS_LOADER_EXPORT___;
